import React from "react";
import { Autocomplete, Box, InputLabel, TextField } from "@mui/material";
import { getDebugLabelProps } from "./shared";

export function SpecsAutocompleteField({
  label,
  value,
  options,
  onChange,
  placeholder,
  debugPath,
}: {
  label: React.ReactNode;
  value: string;
  options: string[];
  onChange: (next: string) => void;
  placeholder?: string;
  debugPath?: string;
}) {
  const debugLabelProps = getDebugLabelProps(debugPath);

  return (
    <Box>
      <InputLabel
        onClick={debugLabelProps.onClick}
        sx={{
          mb: 0.5,
          fontSize: 13,
          ...debugLabelProps.sx,
        }}
      >
        {label}
      </InputLabel>
      <Autocomplete
        freeSolo
        options={options}
        value={value}
        onChange={(_, nextValue) => onChange(nextValue || "")}
        onInputChange={(_, nextValue, reason) => {
          if (reason === "input") onChange(nextValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            size="small"
            variant="standard"
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
            }}
          />
        )}
      />
    </Box>
  );
}
